import { Button, Form } from 'react-bootstrap';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from 'react';
import type { CatalogCategoryKindType } from '@econtractor/types';
import spinnerTitle from 'components/others/spinnerTitle';
import SolarIcon from 'components/icons/SolarIcon';
import { CATALOG_DIR_I18N_NS } from '../model/catalogDirApi';

interface AddDirFormProps {
    kind: CatalogCategoryKindType;
    handleSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
    isSubmitting: boolean;
    nameError?: string;
}

const AddDirForm = ({ kind, handleSubmit, isSubmitting, nameError }: AddDirFormProps) => {
    const { t } = useTranslation([CATALOG_DIR_I18N_NS[kind], 'common']);
    const refInput = useRef<HTMLInputElement>(null);

    useEffect(() => {
        setTimeout(() => {
            refInput.current?.focus();
        }, 100);
    }, []);

    return (
        <Form onSubmit={handleSubmit} className="mx-3 mb-3 p-3 border rounded">
            <Form.Group className="mb-0">
                <label className="form-label text-muted" htmlFor={`addCatalogDirName-${kind}`}>
                    {t('dirs.labelName')}
                </label>
                <div className="d-flex gap-2">
                    <Field
                        innerRef={refInput}
                        required
                        id={`addCatalogDirName-${kind}`}
                        name="name"
                        className={`form-control ${nameError ? 'is-invalid' : ''}`}
                        placeholder={t('dirs.placeholderName')}
                    />
                    <Button type="submit" variant="success" disabled={isSubmitting} className="flex-shrink-0">
                        {spinnerTitle(
                            <>
                                <SolarIcon name="plus" className="fs-14" />
                                <span className="ms-1">{t('common:buttons.create')}</span>
                            </>,
                            isSubmitting,
                            t('common:buttons.creating'),
                        )}
                    </Button>
                </div>
                {nameError ? <div className="invalid-feedback d-block">{nameError}</div> : null}
            </Form.Group>
        </Form>
    );
};

export default AddDirForm;
